import React, { useState, useEffect, useRef } from 'react';
import { Heart, Spade, Diamond, Club, Save, Upload } from 'lucide-react';
import styled from "styled-components";
// import '//index.css';

type Suit = 'spades' | 'hearts' | 'diamonds' | 'clubs';
type Direction = 'N' | 'E' | 'S' | 'W' ;
type BoardNo = number;
type Dealer =  string
type HandDistribution = Record<Suit, string>;
type Distribution = Record<Direction, HandDistribution>;

interface fullDistribution {
  boardNo: BoardNo;
  dealer: Dealer;
  distribution: Distribution;
}


const Generaldiv = styled.div`
    display: flex;
    flex: 0 0 auto;
    width: auto;
    unicode-bidi: isolate;
`;


const Pointsdiv = styled.div`
  flex: 1; 
  position: relative;
`;

const SUITS: Suit[] = ['spades', 'hearts', 'diamonds', 'clubs'];
const DIRECTIONS: Direction[] = ['N', 'E', 'S', 'W'];

const SuitIcon = ({ suit }: { suit: Suit }) => {
  switch (suit) {
    case 'hearts':
      return <Heart className="text-red-500" size={20} />;
    case 'spades':
      return <Spade className="text-gray-900" size={20} />;
    case 'diamonds':
      return <Diamond className="text-red-500" size={20} />;
    case 'clubs':
      return <Club className="text-gray-900" size={20} />;
  }
};

const boardNo = "";

const emptyHand = (): HandDistribution => ({
  hearts: '',
  spades: '',
  diamonds: '',
  clubs: '',
});

const emptyDistribution = (): Distribution => ({
  N: emptyHand(),
  E: emptyHand(),
  W: emptyHand(),
  S: emptyHand(),
});

const emptyFullDistribution = (): fullDistribution => ({
  boardNo: 0,
  dealer: '',
  distribution: emptyDistribution(),
});


let distList: fullDistribution[] = [];

function Rozklady() {
  const [distribution, setDistribution] = useState<Distribution>(emptyDistribution());
  const [savedDistributions, setSavedDistributions] = useState<Distribution[]>([]);
  const [name, setName] = useState('');
  const [boardNo, setBoardNo] = useState<number>(0);
  const [error, setError] = useState('');
  const fileInputRef = useRef<HTMLInputElement>(null);

  useEffect(() => {
    const saved = localStorage.getItem('savedDistributions');
    if (saved) {
      setSavedDistributions(JSON.parse(saved));
    }
  }, []);

  const handleInputChange = (direction: Direction, suit: Suit, value: string) => {
    setDistribution((prev) => ({
      ...prev,
      [direction]: {
        ...prev[direction],
        [suit]: value,
      },
    }));
    setError('');
  };

  const validateDistribution = () => {
    for (const direction of DIRECTIONS) {
      for (const suit of SUITS) {
        if (!distribution[direction][suit].trim()) {
          setError(`Please enter cards for ${suit} in ${direction}`);
          return false;
        }
      }
    }
    return true;
  };

  const handleSave = () => {
    if (!name.trim()) {
      setError('Please enter a name for this distribution');
      return;
    }

    if (!validateDistribution()) {
      return;
    }

    const newSavedDistributions = [...savedDistributions, distribution];
    setSavedDistributions(newSavedDistributions);
    localStorage.setItem('savedDistributions', JSON.stringify(newSavedDistributions));
    setName('');
    setError('Distribution saved successfully!');
  };

const handleNumberChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const value = event.target.value;
    if (value) {
      setBoardNo(parseInt(value));
      if (!isNaN(boardNo)) {
        setDistribution(distList[boardNo].distribution);
      }
    }
}

  const handleFileUpload = (event: React.ChangeEvent<HTMLInputElement>) => {
    const file = event.target.files?.[0];
    if (!file) return;

    const reader = new FileReader();
    reader.onload = (e) => {
      // try {
        const content = e.target?.result as string;
        const lines = content.trim().split('\n');
        
        console.log(lines);
        console.log(distList);

        let newFullDistribution = emptyFullDistribution();
        let newDistribution = emptyDistribution();
        
        lines.forEach((line) => {
          if (line[0] === "["){
            let lineParts = line.substring(1).split(" ");
            let Distr = emptyDistribution();
            switch (lineParts[0]) {
              case "Board":                
                  newFullDistribution.boardNo = parseInt(lineParts[1].slice(1,-3));
                break;
              case "Dealer":
                  newFullDistribution.dealer = lineParts[1].slice(1,-3);
                  break
              case "Deal":
                lineParts.forEach((element, elementIndex) => {
                  let suits: string[];
                  if (elementIndex > 0) {
                    let direction = DIRECTIONS[elementIndex - 1];
                    if (elementIndex === 1) {
                      suits = element.substring(3).split('.');
                    }
                    else {
                      suits = element.split('.');
                      if (suits[3].slice(-2,-1) === ']') {
                        suits[3] = suits[3].slice(0, -3);
                      }
                    }
                    Distr[direction].hearts = suits[0];
                    Distr[direction].spades = suits[1];
                    Distr[direction].diamonds = suits[2];
                    Distr[direction].clubs = suits[3];
                  }
                });
                console.log(Distr);
                newFullDistribution.distribution = {...Distr};
                
                distList.push({...newFullDistribution});
                console.log(distList);
                newDistribution = newFullDistribution.distribution;
                break;  
              default:
                break;
            }
          }
          // const direction = DIRECTIONS[index];
          // const values = line.trim().split(' ');
          
          // if (values.length !== 4) {
          //   throw new Error(`Invalid format in line ${index + 1}. Each line must have 4 values (hearts spades diamonds clubs)`);
          // }
          
          // values.forEach((value, suitIndex) => {
          //   newDistribution[direction][SUITS[suitIndex]] = value;
          // });
        });

        setDistribution(newDistribution);
        setError('Distribution loaded successfully!');
        
      // } catch (err) {
      //   setError(err instanceof Error ? err.message : 'Failed to parse file');
      // }
    };

    reader.readAsText(file);
    if (fileInputRef.current) {
      fileInputRef.current.value = '';
    }
  };

  return (
    <div className="min-h-screen bg-gray-100 py-8">
      <div className="max-w-6xl mx-auto px-4">
        <h1 className="text-3xl font-bold text-gray-900 mb-8 text-center">
          Bridge Hand Distribution
        </h1>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8">
          <div className="space-y-6">
            <div className="bg-white rounded-lg shadow-md p-6">
              <div className="flex items-center justify-between mb-6">
                <h2 className="text-xl font-semibold">Import from File</h2>
                <div className="relative">
                  <input
                    type="file"
                    accept=".txt, .pbn"
                    onChange={handleFileUpload}
                    ref={fileInputRef}
                    className="hidden"
                    id="file-upload"
                  />
                  <label
                    htmlFor="file-upload"
                    className="flex items-center space-x-2 bg-gray-100 hover:bg-gray-200 text-gray-700 px-4 py-2 rounded-md cursor-pointer transition-colors"
                  >
                    <Upload size={20} />
                    <span>Upload File</span>
                  </label>
                </div>
              </div>
              <p className="text-sm text-gray-600 mb-4">
                File format: .pbn <br />
              </p>
            </div>

            <div className="bg-white rounded-lg shadow-md p-6">
              <div className="flex items-center justify-between mb-6">
                <h2 className="text-xl font-semibold">Numer rozdania, które zapisać</h2>
                <div className="mb-4">
                  <input
                    type="text"
                    value={boardNo}
                    placeholder='Enter board number'
                    onChange={handleNumberChange}
                    className="flex-1 rounded-md border-gray-300 shadow-sm focus:border-blue-500 focus:ring-1 focus:ring-blue-500"
                    id="board-no"
                  />
                  <label
                    className="flex items-center space-x-3"
                  >
                  </label>
                </div>
              </div>
            </div>

            {DIRECTIONS.map((direction) => (
              <div key={direction} className="bg-white rounded-lg shadow-md p-6">
                <h2 className="text-xl font-semibold mb-4">
                  {direction} Hand
                </h2>
                <div className="space-y-4">
                  {SUITS.map((suit) => (
                    <div key={suit} className="flex items-center space-x-3">
                      <SuitIcon suit={suit} />
                      <input
                        type="text"
                        value={distribution[direction][suit]}
                        onChange={(e) => handleInputChange(direction, suit, e.target.value)}
                        placeholder={`Enter ${suit}...`}
                        className="flex-1 rounded-md border-gray-300 shadow-sm focus:border-blue-500 focus:ring-1 focus:ring-blue-500"
                      />
                    </div>
                  ))}
                </div>
              </div>
            ))}
          </div>

          <div className="space-y-6">
            <div className="bg-white rounded-lg shadow-md p-6">
              <h2 className="text-xl font-semibold mb-4">Save Distribution</h2>
              <div className="space-y-4">
                <input
                  type="text"
                  value={name}
                  onChange={(e) => setName(e.target.value)}
                  placeholder="Enter a name for this distribution"
                  className="w-full rounded-md border-gray-300 shadow-sm focus:border-blue-500 focus:ring-1 focus:ring-blue-500"
                />
                <button
                  onClick={handleSave}
                  className="w-full flex items-center justify-center space-x-2 bg-blue-500 text-white px-4 py-2 rounded-md hover:bg-blue-600 transition-colors"
                >
                  <Save size={20} />
                  <span>Save Distribution</span>
                </button>
                {error && (
                  <p className={`text-sm ${error.includes('successfully') ? 'text-green-600' : 'text-red-600'}`}>
                    {error}
                  </p>
                )}
              </div>
            </div>

            <div className="bg-white rounded-lg shadow-md p-6">
              <h2 className="text-xl font-semibold mb-4">Saved Distributions</h2>
              <div className="space-y-4">
                {savedDistributions.map((dist, index) => (
                  // <div key={index} className="border rounded-md p-4">
                  //   <h3 className="font-medium mb-2">Distribution {index + 1}</h3>
                  //   {DIRECTIONS.map((direction) => (
                  //     <div key={direction} className="mb-2">
                  //       <span className="font-medium">{direction}: </span>
                  //       {SUITS.map((suit) => (
                  //         <span key={suit} className="mr-4">
                  //           <SuitIcon suit={suit} />
                  //           {dist[direction][suit]}
                  //         </span>
                  //       ))}
                  //     </div>
                  //   ))}
                  // </div>
                  <div key={index} className="col-12 col-lg-8">
                    <div className="row g-0">
                        <Generaldiv className="col col-auto" >
                          {/* style="c;" */}
                            <div className="" >
                                <span className=" text-center px-1 " id="tabB_bTitle0"><h1 className="mb-0">24</h1>None / W</span>
                                    {/* // style="flex: 1" */}
                                    <div className='mt-2'>
                                    <span className="align-self-left pr-3"  style={{flexBasis: "auto"}}  id="tabB_wCards0">
                                      {/* style="flex-basis: auto;" */}
                                    <img className="table-img float-left" src="https://cdn.tournamentcalculator.com/spades.gif"/>
                                    {dist.W.spades}<br/>
                                    <img className="table-img float-left" src="https://cdn.tournamentcalculator.com/hearts.gif"/>
                                    {dist.W.hearts}<br/>
                                    <img className="table-img float-left" src="https://cdn.tournamentcalculator.com/diamonds.gif"/>
                                    {dist.W.diamonds}<br/>
                                    <img className="table-img float-left" src="https://cdn.tournamentcalculator.com/clubs.gif"/>
                                    {dist.W.clubs}</span>
                                </div>
                                <Pointsdiv className="align-self-left text-start" style={{flex: "1", position: "relative"}}>
                                  {/* style="flex: 1; position: relative;" */}
                                    <table id="tabB_tableHcp0" className="text-center fw-bold font-italic mt-1 ml-3">
                                        <tbody><tr>
                                            <td></td>
                                            <td id="tabB_hcpNorth0"></td>
                                            <td></td>
                                        </tr>
                                        <tr>
                                            <td id="tabB_hcpWest0"></td>
                                            <td></td>
                                            <td id="tabB_hcpEast0"></td>
                                        </tr>
                                        <tr>
                                            <td>
                                            </td>
                                            <td id="tabB_hcpSouth0"></td>
                                            <td></td>
                                        </tr>
                                    </tbody></table>
                                </Pointsdiv>
                            </div>
                        </Generaldiv>
                        <div className="col">
                            <div className="row">
                                <div className="col" id="tabB_nCards0">
                                    <img className="table-img float-left" src="https://cdn.tournamentcalculator.com/spades.gif"/>
                                    {dist.N.spades}<br/>
                                    <img className="table-img float-left" src="https://cdn.tournamentcalculator.com/hearts.gif"/>
                                    {dist.N.hearts}<br/>
                                    <img className="table-img float-left" src="https://cdn.tournamentcalculator.com/diamonds.gif"/>
                                    {dist.N.diamonds}<br/>
                                    <img className="table-img float-left" src="https://cdn.tournamentcalculator.com/clubs.gif"/>
                                    {dist.N.clubs}</div>
                                <div className="col d-lg-none text-end" id="tabB_tricksNsSmall0"><table className="table table-sm mb-0"><thead><tr><th scope="col" className="align-middle text-center"></th><th scope="col" className="align-middle text-center"><img className="table-img" src="https://cdn.tournamentcalculator.com/notrump.gif"/></th><th scope="col" className="align-middle text-center"><img className="table-img" src="https://cdn.tournamentcalculator.com/spades.gif"/></th><th scope="col" className="align-middle text-center"><img className="table-img" src="https://cdn.tournamentcalculator.com/hearts.gif"/></th><th scope="col" className="align-middle text-center"><img className="table-img" src="https://cdn.tournamentcalculator.com/diamonds.gif" /></th><th scope="col" className="align-middle text-center"><img className="table-img" src="https://cdn.tournamentcalculator.com/clubs.gif"/></th></tr></thead><tbody><tr><td>N</td><td className="text-center">0</td><td className="text-center">0</td><td className="text-center">0</td><td className="text-center">6</td><td className="text-center">7</td></tr><tr><td>S</td><td className="text-center">0</td><td className="text-center">0</td><td className="text-center">0</td><td className="text-center">6</td><td className="text-center">7</td></tr></tbody></table></div>
                            </div>
                            <div className="row g-0">
                                <div className="col-auto bImage"  style={{
                                                                  width: '110px',
                                                                  height: '110px',
                                                                  objectFit: 'cover' // lub 'contain', 'fill', 'scale-down'
                                                                }} id="tabB_bImage0"><img className="img-fluid" src="https://cdn.tournamentcalculator.com/boardBBW.png"/></div>
                                <div className="col">
                                    <div className="d-flex h-100">
                                        <span className="align-self-center pl-3" id="tabB_eCards0">
                                            <img className="table-img float-left" src="https://cdn.tournamentcalculator.com/spades.gif"/>
                                            {dist.E.spades}<br/>
                                            <img className="table-img float-left" src="https://cdn.tournamentcalculator.com/hearts.gif"/>
                                            {dist.E.hearts}<br/>
                                            <img className="table-img float-left" src="https://cdn.tournamentcalculator.com/diamonds.gif"/>
                                            {dist.E.diamonds}<br/>
                                            <img className="table-img float-left" src="https://cdn.tournamentcalculator.com/clubs.gif"/>
                                            {dist.E.clubs}</span>
                                    </div>
                                </div>
                            </div>
                            <div className="row">
                                <div className="col" id="tabB_sCards0">
                                    <img className="table-img float-left" src="https://cdn.tournamentcalculator.com/spades.gif"/>
                                    {dist.S.spades}<br/>
                                    <img className="table-img float-left" src="https://cdn.tournamentcalculator.com/hearts.gif"/>
                                    {dist.S.hearts}<br/>
                                    <img className="table-img float-left" src="https://cdn.tournamentcalculator.com/diamonds.gif"/>
                                    {dist.S.diamonds}<br/>
                                    <img className="table-img float-left" src="https://cdn.tournamentcalculator.com/clubs.gif"/>
                                    {dist.S.clubs}
                                </div>
                                <div className="col d-lg-none text-end" id="tabB_tricksWeSmall0">
                                    <table className="table table-sm mb-0">
                                        <thead>
                                        <tr><th scope="col" className="align-middle text-center"></th><th scope="col" className="align-middle text-center">
                                            <img className="table-img" src="https://cdn.tournamentcalculator.com/notrump.gif"/></th>
                                            <th scope="col" className="align-middle text-center"><img className="table-img" src="https://cdn.tournamentcalculator.com/spades.gif"/></th><th scope="col" className="align-middle text-center"><img className="table-img" src="https://cdn.tournamentcalculator.com/hearts.gif"/></th><th scope="col" className="align-middle text-center"><img className="table-img" src="https://cdn.tournamentcalculator.com/diamonds.gif"/></th><th scope="col" className="align-middle text-center"><img className="table-img" src="https://cdn.tournamentcalculator.com/clubs.gif"/></th></tr></thead><tbody><tr><td>W</td><td className="text-center">13</td><td className="text-center">13</td><td className="text-center">13</td><td className="text-center">6</td><td className="text-center">6</td></tr><tr><td>E</td><td className="text-center">13</td><td className="text-center">12</td><td className="text-center">13</td><td className="text-center">6</td><td className="text-center">6</td></tr></tbody></table>
                                </div>
                            </div>
                        </div>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Rozklady;